"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function isMobile(screenSize) {

    var mobile = false;

    if (screenSize === "xs" || screenSize === "sm") {
        mobile = true;
    }

    return mobile;
}

exports.default = isMobile;